export enum OS {
    Window = "Windows",
    Mac = "MacOS",
    Linux = "Linux",
    Unix = "Unix"
}

export function getOs(): OS {
    let os = navigator.userAgent;
    let finalOs = OS.Window;
    if (os.search('Mac') !== -1) {
        finalOs = OS.Mac;
    }
    else if (os.search('X11') !== -1 && !(os.search('Linux') !== -1)) {
        finalOs = OS.Unix;
    }
    else if (os.search('Linux') !== -1 && os.search('X11') !== -1) {
        finalOs = OS.Linux
    }

    return finalOs
}